import { ServiceRoute } from "../../base/service-route";
import { CoreService } from "../../base/core";
import { Injectable } from "@angular/core";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class StaticValueService {
  constructor(private core: CoreService) {}

  bankList(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.bankList + value,
      new CommonHttpOption().headers
    );
  }


  getPhoneType(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.getPhoneType + value,
      new CommonHttpOption().headers
    );
  }

  getWeekDays(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.weekDays + value,
      new CommonHttpOption().headers
    );
  }

  companyStatusType(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.companyStatusType + value,
      new CommonHttpOption().headers
    );
  }

  genderType(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.genderType + value,
      new CommonHttpOption().headers
    );
  }

  branchType(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.branchType + value,
      new CommonHttpOption().headers
    );
  }

  userType(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.userType + value,
      new CommonHttpOption().headers
    );
  }

  roomType(
    value: boolean,
    page: number = 1,
    pageSize: number = 10
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.roomType + value,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  relationType(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.relationType + value,
      new CommonHttpOption().headers
    );
  }

  courseStatus(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.courseStatus + value,
      new CommonHttpOption().headers
    );
  }

  discountGroupType(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.discountGroupType + value,
      new CommonHttpOption().headers
    );
  }

  degree(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.degree + value,
      new CommonHttpOption().headers
    );
  }

  ageCategory(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.ageCategory + value,
      new CommonHttpOption().headers
    );
  }

  languageList(value: boolean): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.languageList + value,
      new CommonHttpOption().headers
    );
  }

  ContractType(page: Number = 1, pageSize: Number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.ContractType,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getRelationType(page: Number = 1, pageSize: Number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.relationType,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  invoiceStatus(query:boolean=false,page: Number = 1, pageSize: Number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.InvoiceStatus + query,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  allInvoiceItemType(query:boolean=false,page: Number = 1, pageSize: Number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.staticValue.AllInvoiceItemType + query,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getQuestionType(): Observable<any> {
    return this.core.get(ServiceRoute.staticValue.questionType, 
      new CommonHttpOption().headers,);
  }
}
